'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.minutesFromNow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/minutesFromNow.js
// module id = 712
// module chunks = 0